import { render, staticRenderFns } from "./VerifyCode.vue?vue&type=template&id=da98fb64&scoped=true"
import script from "./VerifyCode.vue?vue&type=script&lang=js"
export * from "./VerifyCode.vue?vue&type=script&lang=js"
import style0 from "./VerifyCode.vue?vue&type=style&index=0&id=da98fb64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da98fb64",
  null
  
)

export default component.exports